/*
 * @Date: 2023-11-28 18:30:45
 * @LastEditors: shizheng 64840669+code-cola-js@users.noreply.github.com
 * @LastEditTime: 2023-12-14 16:55:31
 * @FilePath: \hisea-ssr\src\components\FilterModal\CurrentFilters\currentFilter.js
 */
import { useCallback } from 'react';
import { X as Remove } from 'react-feather';
import { useIntl } from 'react-intl';

import { useStyle } from '@/classify';
import { useWindowSize } from '@/common/hooks/useWindowSize';
import Icon from '../../Icon';
import Trigger from '../../Trigger';
import defaultClasses from './currentFilter.module.css';

const CurrentFilter = props => {
  const { group, item, removeItem, onRemove = null, isResearch = true } = props;
  const classes = useStyle(defaultClasses, props.classes);
  const { formatMessage } = useIntl();
  const windowSize = useWindowSize();

  const isMobile = windowSize.innerWidth <= 960;

  const handleClick = useCallback(() => {
    console.log('removeItem', group, item);
    removeItem({
      group,
      item,
    });

    if (typeof onRemove === 'function' && isResearch) {
      onRemove(group, item);
    }
  }, [group, item, removeItem, onRemove]);

  const ariaLabel = formatMessage(
    {
      id: 'filterModal.action.clearFilterItem.ariaLabel',
      defaultMessage: 'Clear filter "{name}"',
    },
    {
      name: item.label ? item.label : item.title,
    },
  );

  return (
    <span className={classes.root}>
      <span className={classes.text}>
        {group === 'price' ? item?.[0] + '-' + item?.[1] : item.label ? item.label : item.title}
      </span>
      <Trigger
        action={handleClick}
        ariaLabel={ariaLabel}
      >
        <Icon
          size={16}
          src={Remove}
        />
      </Trigger>
    </span>
  );
};

export default CurrentFilter;
